// @ts-nocheck
jQuery(document).ready(function ($) {
    if(jQuery().slick) {
        $('.slick-inline').slick({
            prevArrow: '<button type="button" class="slick-prev"><svg class="icon icon-fa custom--icon-fa-chevron-left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!-- Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="icon icon-fa custom--icon-fa-chevron-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!-- Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/></svg></button>'
        });
        $('.carousel-tabs-section-widget ul.tabs li.tab label').click(function () {
            var thisTabNumber = $(this).attr('data-tab-number');
            var thisCarousel = $(this).closest('.tabs-group').find('.tab-content.tab-content-' + thisTabNumber + ' .slick-inline');
            if ($(thisCarousel).hasClass('needs-slick-re-init')) {
                $(thisCarousel).slick('unslick');
                $(thisCarousel).slick();
                $(thisCarousel).removeClass('needs-slick-re-init');
            }
        });
        $('.carousel-tabs-section-widget .tab-content > h3 > label').click(function () {
            var thisCarousel = $(this).closest('.tab-content').find('.slick-inline');
            if ($(thisCarousel).hasClass('needs-slick-re-init')) {
                $(thisCarousel).slick('unslick');
                $(thisCarousel).slick();
                $(thisCarousel).removeClass('needs-slick-re-init');
            }
        });
    }

    $('.c2e img').each(function(){
        var thisImgSrc = $(this).attr('src');
        $(this).wrap('<a href="' + thisImgSrc + '" class="c2e-link"></a>');
        if($(this).closest('.c2e').hasClass('with-tag')){
            $('<span class="c2e-text">+ CLICK TO ZOOM</span>').insertAfter($(this));
        }
    });



    if(jQuery().colorbox) {
      $("a.c2e-link").colorbox({maxWidth:'95%',maxHeight:'95%', rel:'group1'});
      $(document).on('click', '.colorbox-trigger', function(e) {
          e.preventDefault(); // Prevent default link behavior if it's an anchor tag
          $.colorbox({href:$(this).attr('href'), open:true, maxWidth:'95%',maxHeight:'95%'});
          return false;
      });
    }

    /* Begin: Maps Widget Scripts */
    $('.mapswidget .mapswidget-block-content').click(function(){
        $(this).closest('.mapswidget').find('.mapswidget-js-item').removeClass('active');
        var desiredLocation = $(this).attr('data-id');
        $(this).addClass('active');
        $(this).closest('.mapswidget').find('.mapswidget-map-code[data-id="'+ desiredLocation + '"]').addClass('active');
    });
    /* End: Maps Widget Scripts */


    /* Begin: Custom Add to Cart */
      var cartCountOnPageLoad = parseInt($('.cart-bubble__text-count').text());
      var newCartCount = 0;
      function customAtc(variantId, formId, quantity = 1) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        })
        .then(markFormActive(formId))
        .then(response => response.json())
        .then(cart => {
          markFormActive(formId);
          setTimeout(function(){
            markFormInactive(formId);
          }, 1000);
          updateCartCount();
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          markFormInactive(formId);
        });
      }
      function markFormActive(formId){
        jQuery(document).ready(function ($) {
          // console.log('Marking form active: ' + formId);
          $(formId).addClass('active');
        });
      }
      function markFormInactive(formId){
        jQuery(document).ready(function ($) {
          // console.log('Marking form inactive: ' + formId);
          $(formId).removeClass('active');
        });
      }
      function updateCartCount() {
        if(newCartCount == 0){
          newCartCount = cartCountOnPageLoad;
        }
        newCartCount++;

        $('#cw-cart-item-count').text(newCartCount);
        $('.cart-bubble__text-count').text(newCartCount);
        $('.cart-bubble__text .visually-hidden').text('Total items in cart: ' + newCartCount);
      }
      $('.custom--atc form').on('submit', function(e){
        e.preventDefault();
        var variantId = $(this).find('.custom--atc-variant-id').val();
        var thisFormId = $(this).attr('data-form-id');
        customAtc(variantId, 'form[data-form-id="' + thisFormId + '"]');
      });
      /* End: Custom Add to Cart */

      /* Begin: Automatically Check the In Stock filter on Collection Pages. */
      /*
      $('.facet-checkbox__text-label').each(function(){
        var thisText = $(this).text();
        if(thisText){
          var thisText = thisText.toUpperCase();
          var thisText = thisText.trim();
        }
        if(thisText == 'IN STOCK'){
          $(this).closest('.facets__label').find('input[name="filter.v.availability"]').prop("checked", true);
        }
      });
      */
      /* End: Automatically Check the In Stock filter on Collection Pages. */


      /* Begin: Hulkapps output to modal conversion */
      if($('.product-info-inner-box').length){
        // Handle Close
        $('body').on('click', '.hulkapps-volumes', function(){
          $('body').removeClass('qty-pricing-modal-active');
        });

        // Handle Open
        $('body').on('click', '.show-qty-pricing', function(e){
          e.preventDefault();
          $('body').addClass('qty-pricing-modal-active');
        });

        function checkForQtyPricing(){
          console.log('checking for qty pricing...');
          if($('.hulkapps-volumes').length){
            $('body').addClass('has-qty-pricing');
            if(intervalId){
              clearInterval(intervalId);
            }
          }
        }

        // Check on body load to see if the div exists.
        checkForQtyPricing();

        // Check every three seconds
        const intervalId = setInterval(checkForQtyPricing, 3000);
      }
      /* End: Hulkapps output to modal conversion */


      /* Begin: Custom Swatches: Add a select box */
      $('body').on('click', '.manual-option-selector-box-current', function(e){
        e.preventDefault();
        e.stopPropagation(); 
        if($(this).closest('.manual-option-selector-box').hasClass('open')){
          $(this).closest('.manual-option-selector-box').removeClass('open');
          $(this).closest('.manual-option-selector-box').find('.manual-option-selector-box-dropdown').slideUp();
        } else {
          $(this).closest('.manual-option-selector-box').addClass('open');
          $(this).closest('.manual-option-selector-box').find('.manual-option-selector-box-dropdown').slideDown();
        }
      });
      $('body').on('click', '.manual-option-selector-box-option', function(){
        var thisText = $(this).text();
        var thisTarget= $(this).attr('data-target');
        $(this).closest('.manual-option-selector-box').removeClass('open');
        $(this).closest('.manual-option-selector-box').find('.manual-option-selector-box-dropdown').slideUp();
        $(this).closest('.manual-option-selector-box').find('.manual-option-selector-box-current-text').text(thisText);
        $(this).closest('.manual-option-selector-box').find('.manual-option-selector-box-option').removeClass('is-selected');
        $(this).addClass('is-selected');

        /*$(this).closest('.custom--product-options-list-container').find('input[data-option-value-id= "' + thisTarget + '"]').closest('.variant-option__button-label').click();*/
        var $input = $(this).closest('.custom--product-options-list-container').find('input[data-option-value-id= "' + thisTarget + '"]');
        $input.prop('checked', true);
        $input[0].dispatchEvent(new Event('change', { bubbles: true }));
      });
      /* End: Custom Swatches: Add a select box */

});
